import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Login = () => {
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    useEffect(() => {
        const fetchFeatures = async () => {
            try {
                const response = await axios.get('/cardiast/features');
                setFeatures(response.data.data);
            } catch (error) {
                console.error("Error fetching features:", error);
            } finally {
                setLoading(false); // Set loading to false after fetching
            }
        };

        fetchFeatures();
    }, []);

    return (
        <div className="login-container">
            <div className="content-card">
                {loading ? (
                    <p>Loading features...</p>
                ) : (
                    features && features.length > 0 ? (
                        <Slider {...settings}>
                            {features.map((item) => {
                                return (
                                    <div key={item.id} className="feature-item">
                                        <img src={item.imageLink} alt={item.title} />
                                        <h2>{item.title}</h2>
                                        <p>{item.brief}</p>
                                    </div>
                                );
                            })}
                        </Slider>
                    ) : (
                        <p>No features available</p> 
                    ) 
                )}

            </div>
            <div className="button-container">
                <a href="https://auth.cardiast.com/?type=login&return=https://app.cardiast.com/" className="login">Login</a>
                <a href="https://cardiast.com/app/sign-up" className="sign-up">Sign up</a>
            </div>
        </div>
    );
};

export default Login;
